// Aulyn motion — scroll reveal + image fade-in. No hover effects.
// Targets every content unit inside Cascade sections, not just direct <section> children.

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Section containers in Cascade theme.
  var SECTION_ROOTS = ['main .shopify-section', 'main section'];

  // Content units that fade in when they enter view.
  // Broad — anything that visually matters as a "block" of content.
  var CONTENT_SELECTORS = [
    'h1', 'h2', 'h3', 'h4',
    'p',
    '.rte',
    '.heading',
    '.subheading',
    '.product-card',
    '.product-grid > *',
    '.collection-grid > *',
    '.card',
    '.media',
    'picture',
    '> img', '> a > img', '> div > img',
    'figure',
    'blockquote',
    '.button', 'a.button', '.btn',
    '.buttons',
    '.cta',
    '.faq',
    '.testimonial',
    '.image-with-text__content',
    '.image-with-text__media',
    '.multicolumn-card',
    '.blog-card',
    '.product-story',
    '.product-teaser',
    '.product-details-accordion',
    'ul:not(.menu):not(.list-menu):not(.product-form-options)',
    'ol'
  ];

  function isExcluded(el) {
    if (!el) return true;
    if (el.classList && el.classList.contains('no-reveal')) return true;
    return !!el.closest('header, footer, .header, .footer, nav, .nav, .cart-drawer, .header-group');
  }

  function tagForReveal() {
    var seen = new Set();
    var sectionRoots = [];
    SECTION_ROOTS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (root) {
        if (isExcluded(root)) return;
        sectionRoots.push(root);
      });
    });

    // For each section, find all matching content elements at any depth.
    sectionRoots.forEach(function (root) {
      CONTENT_SELECTORS.forEach(function (sel) {
        try {
          root.querySelectorAll(sel).forEach(function (el) {
            if (seen.has(el)) return;
            if (isExcluded(el)) return;
            // Skip if an ancestor inside the same section is already tagged
            // (avoids double-revealing parent + child).
            var ancestor = el.parentElement;
            var alreadyCovered = false;
            while (ancestor && ancestor !== root) {
              if (ancestor.classList && ancestor.classList.contains('reveal')) {
                alreadyCovered = true;
                break;
              }
              ancestor = ancestor.parentElement;
            }
            if (alreadyCovered) return;
            el.classList.add('reveal');
            seen.add(el);
          });
        } catch (e) { /* invalid selector */ }
      });
    });

    // Stagger grid children for cascade.
    document.querySelectorAll('.product-grid, .collection-grid, [data-stagger]').forEach(function (grid) {
      var children = grid.querySelectorAll(':scope > .reveal');
      children.forEach(function (child, i) {
        var delay = Math.min(i * 80, 480);
        if (delay) child.setAttribute('data-reveal-delay', String(delay));
      });
    });

    // Stagger image-with-text children (media + content).
    document.querySelectorAll('.image-with-text').forEach(function (block) {
      var children = block.querySelectorAll('.reveal');
      children.forEach(function (child, i) {
        var delay = Math.min(i * 120, 240);
        if (delay) child.setAttribute('data-reveal-delay', String(delay));
      });
    });
  }

  function observeReveals() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -6% 0px',
      threshold: 0.08
    });

    document.querySelectorAll('.reveal').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // Already in viewport: snap to revealed state instantly (no animation for above-fold).
      if (rect.top < window.innerHeight * 0.95 && rect.bottom > 0) {
        el.classList.add('is-revealed');
      } else {
        observer.observe(el);
      }
    });
  }

  function tagImagesForFade() {
    document.querySelectorAll('main img:not([data-image-fade])').forEach(function (img) {
      if (isExcluded(img)) return;
      if (img.dataset.noFade !== undefined) return;
      // Never hide LCP candidates: eager-loaded or initially visible images
      // paint immediately instead of waiting for JS + fade.
      if (img.loading === 'eager') return;
      var r = img.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return;
      img.setAttribute('data-image-fade', '');
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
  }

  function init() {
    tagForReveal();
    observeReveals();
    tagImagesForFade();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
